import { createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

const initialState = {
    stats: null,
    athletes: null,
    groups: null,
    coaches: null,
    assessments: null,
    workouts: null,
    // Used for testing purposes
    billingLocalTimestamp: moment().local() // moment().add(0, 'days').local()
}

const organizationSlice = createSlice({
    name: 'organization',
    initialState,
    reducers: {
        setOrganizationStats: (state, action) => { state.stats = action.payload },
        setOrganizationAthletes: (state, action) => { state.athletes = action.payload },
        setOrganizationGroups: (state, action) => { state.groups = action.payload },
        updateOrganizationAthleteAssignedTrainerId: (state, action) => { 
            const athleteIndex = state.athletes.findIndex(athlete => parseInt(action.payload.athleteId) === parseInt(athlete.id))

            // console.log(athleteIndex)

            if (athleteIndex !== -1) {
                state.athletes[athleteIndex].organizationTrainerId = action.payload.organizationTrainerId
            }
        },
        setOrganizationCoaches: (state, action) => { state.coaches = action.payload },
        setOrganizationAssessments: (state, action) => { state.assessments = action.payload },
        setOrganizationWorkouts: (state, action) => { state.workouts = action.payload },
        updateOrganizationGroupOwnerUserId: (state, action) => {
            const groupIndex = state.groups.findIndex(group => parseInt(action.payload.groupId) === parseInt(group.id))

            if (groupIndex !== -1) {
                state.groups[groupIndex].ownerUserId = action.payload.ownerUserId
            }
        },
        resetOrganizationGroups: (state) => { state.groups = null },
        resetOrganizationState: () => initialState
    },
});

export const {
    setOrganizationStats,
    setOrganizationAthletes,
    setOrganizationGroups,
    updateOrganizationAthleteAssignedTrainerId,
    updateOrganizationGroupOwnerUserId,
    setOrganizationCoaches,
    setOrganizationAssessments,
    setOrganizationWorkouts,
    resetOrganizationGroups,
    resetOrganizationState
} = organizationSlice.actions;

export default organizationSlice.reducer;